<template>
  <fragment>
    <section v-if="relData.length">
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex justify-content-center py-4">
            <button
              type="button"
              class="btn btn-vermelho mr-1"
              @click="printPage"
            >
              DOWNLOAD PDF
            </button>
            <button
              type="button"
              class="btn btn-verde ml-1"
              @click="exportTableToCSV"
            >
              DOWNLOAD XLSX
            </button>
          </div>
        </div>
      </div>
      <div class="container-fluid" id="relcontainer">
        <div class="row bg-white p-2 mb-3 mx-1">
          <div
            class="col-2 border-right-1"
            style="border-right: 1px solid #aaa"
          >
            <img src="@/assets/img/logo.png" class="img-fluid" alt="logo" />
          </div>
          <div
            class="col-8 d-flex align-items-start flex-column justify-content-center"
          >
            <h2 class="text-uppercase flex-item align-items-center">
              <p v-if="this.urlParams.tipo == 'RelatorioChequeRessarcido'">
                Relatório Cheque Ressarcido
              </p>
              <p
                v-if="
                  this.urlParams.tipo == 'RelatorioExtratoUtilizacaoCoParUnimed'
                "
              >
                Extrato de Utilizações Co-Participativo Unimed
              </p>
              <p v-if="this.urlParams.tipo == 'RelatorioChequeGarantido'">
                Relatório Cheque Garantido
              </p>
              <p v-if="this.urlParams.tipo == 'RelatorioChequeRecuperacao'">
                Relatório Cheque em Recuperação
              </p>
              -
              {{ urlParams.periodo }}
            </h2>
            <p>
              {{
                $store.state.userDetails.dadosCadastraisAssociado[0]
                  .nomecomercial
              }}
            </p>
            <p class="small">
              {{
                $store.state.userDetails.dadosCadastraisAssociado[0]
                  .codsociO_TEMP
              }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="d-flex justify-content-center align-items-center mt-4">
              <table
                class="table table-responsive table-striped"
                v-if="this.urlParams.tipo == 'RelatorioChequeRecuperacao'"
              >
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Agência</th>
                    <th scope="col">Autorização</th>
                    <th scope="col">Banco</th>
                    <th scope="col">Cheque</th>
                    <th scope="col">Documento</th>
                    <th scope="col">Val. Cheque</th>
                    <th scope="col">Val. Recuperado</th>
                    <th scope="col">Val. Ressarcido</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in relData" :key="index">
                    <th scope="row">{{ item.agencia }}</th>
                    <td>{{ item.autoriz }}</td>
                    <td>{{ item.banco }}</td>
                    <td>{{ item.cheque }}</td>
                    <td>{{ item.documento }}</td>
                    <td>{{ item.vlrcheque | currency }}</td>
                    <td>{{ item.vlrrecuperado | currency }}</td>
                    <td>{{ item.vlrressarcido | currency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-center align-items-center mt-4">
              <table
                class="table table-responsive table-striped"
                v-if="this.urlParams.tipo == 'RelatorioChequeRessarcido'"
              >
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Agência</th>
                    <th scope="col">Autorização</th>
                    <th scope="col">Banco</th>
                    <th scope="col">Cheque</th>
                    <th scope="col">Documento</th>
                    <th scope="col">Val. Cheque</th>
                    <th scope="col">Val. Garantido</th>
                    <th scope="col">Val. Ressarcido</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in relData" :key="index">
                    <th scope="row">{{ item.agencia }}</th>
                    <td>{{ item.autoriz }}</td>
                    <td>{{ item.banco }}</td>
                    <td>{{ item.cheque }}</td>
                    <td>{{ item.documento }}</td>
                    <td>{{ item.vlrcheque | currency }}</td>
                    <td>{{ item.vlrgarantido | currency }}</td>
                    <td>{{ item.vlrressarcido | currency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-center align-items-center mt-4">
              <table
                class="table table-responsive table-striped"
                v-if="this.urlParams.tipo == 'RelatorioChequeGarantido'"
              >
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Código Sócio</th>
                    <th scope="col">Desc</th>
                    <th scope="col">Filiação</th>
                    <th scope="col">Vencimento</th>
                    <th scope="col">Tax. Min</th>
                    <th scope="col">Val. Min</th>
                    <th scope="col">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in relData" :key="index">
                    <th scope="row">{{ item.codsocio }}</th>
                    <td>{{ item.descricao }}</td>
                    <td>{{ item.dtfiliacao }}</td>
                    <td>{{ item.dtvencti }}</td>
                    <td>{{ item.taxaminima | currency }}</td>
                    <td>{{ item.valminimo | currency }}</td>

                    <td>{{ item.valor | currency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-center align-items-center">
              <table
                class="table table-responsive table-striped fit-content"
                v-if="
                  this.urlParams.tipo == 'RelatorioExtratoUtilizacaoCoParUnimed'
                "
              >
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Código Vida</th>
                    <th scope="col">Desc</th>
                    <th scope="col">Dt. Atendimento</th>
                    <th scope="col">Num. Carteirinha</th>
                    <th scope="col">PF</th>
                    <th scope="col">Quantidade</th>
                    <th scope="col">Valor Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in relData" :key="index">
                    <th scope="row">{{ item.codvida }}</th>
                    <td>{{ item.descrservico }}</td>
                    <td>{{ item.dtatendimento | filterData }}</td>
                    <td>{{ item.numcarteira }}</td>
                    <td>{{ item.pf }}</td>
                    <td>{{ item.quantidade }}</td>
                    <td>{{ item.vlrtotal | currency }}</td>
                  </tr>
                </tbody>
                <hr />
                <tbody class="d-flex w-100">
                  <tr class="d-flex justify-content-between">
                    <td class="font-weight-bold">Valor Total Somado</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{ total | currency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-else>
      <loading />
    </section>
  </fragment>
</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import tableexport from "tableexport";
// eslint-disable-next-line no-unused-vars
import { formata } from "../../helpers";
export default {
  name: "visualizar-relatorio",
  data() {
    return {
      total: 0,
      relData: {},
    };
  },
  filters: {
    filterData(val) {
      return val.replaceAll("/", "-");
    },
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
  props: {
    tipo: String,
    periodo: String,
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  methods: {
    downloadCSV() {
      // var csvFile;
      // var downloadLink;
      // csvFile = new Blob([csv], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;" });
      // downloadLink = document.createElement("a");
      // downloadLink.download = filename;
      // downloadLink.href = window.URL.createObjectURL(csvFile);
      // downloadLink.style.display = "none";
      // document.body.appendChild(downloadLink);
      // downloadLink.click();
    },
    exportTableToCSV() {
      // var csv = [];
      // var rows = document.querySelectorAll("table tr");

      // for (var i = 0; i < rows.length; i++) {
      //   var row = [],
      //     cols = rows[i].querySelectorAll("td, th");

      //   for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText);

      //   csv.push(row.join(","));
      // }
      // this.downloadCSV(csv.join("\n"), this.urlParams.tipo + ".xls");
      document.querySelector(".xlsx").click();
    },
    getRelatorio() {
      this.$http
        .get(
          `/api/CdlBh/${this.urlParams.tipo}?AnoMes=${this.urlParams.periodo}`
        )
        .then((response) => {
          this.relData = response.data.coparticipacao;
        })
        .then(() => {
          this.relData.forEach((el) => {
            this.total += el.vlrtotal;
          });
        })
        .then(() => {
          tableexport(document.getElementsByTagName("table"));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    printPage() {
      const input = document.getElementById("relcontainer");
      const divHeight = input.clientHeight;
      const divWidth = input.clientWidth;
      const ratio = divHeight / divWidth;

      html2canvas(input, { scale: "1" }).then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg");
        const pdfDOC = new jsPDF("l", "mm", "a4"); //  use a4 for smaller page

        const width = pdfDOC.internal.pageSize.getWidth();
        let height = pdfDOC.internal.pageSize.getHeight();
        height = ratio * width;

        pdfDOC.addImage(imgData, "JPEG", 0, 0, width - 0, height - 10);
        pdfDOC.save(`${this.urlParams.tipo}-${this.urlParams.periodo}.pdf`); //Download the rendered PDF.
      });
    },
  },
  created() {
    this.getRelatorio();
  },
};
</script>

<style lang="scss" scoped>
.flex-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-weight: 900;
  text-align: left;
}
table {
  width: fit-content;
  margin-top: 20px;
}
td {
  font-size: 0.8rem;
}
</style>
